import { createRoutesView } from 'atomic-router-react'
import { StartPageRoute } from './startPage'
import { OnboardingPageRoute } from './onboardingPage'
import { MainPageRoute } from './main'
import { ProfilePageRoute } from './profile'
import { TestPageRoute } from './testPage'
import { AuthPageRoute } from './authPage'
import { UpdatePageRoute } from './rescorePage'
import { PrivateErrorPageRoute } from './errors'
import { OtherErrorPageRoute } from './errors/otherError'
import { newAuthRoute } from './newAuthPage'
import { CasesListPageRoute } from './casesListPage'
import { TonConnectPageRoute } from './tonConnect'
import { RewardPageRoute } from './rewardPage'
import { LastProgressRoute } from './lastProgress'
import { DevToolsRoute } from './devToolsPage'
import { DoubleConnectionErrorPageRoute } from './errors/doubleConnection'
import { ConnectSteamPageRoute } from './connectSteamPage'
import { NewsRoute } from './news'
import { TransactionStatusRoute } from './transactionStatus'
import { TransactionHistoryRoute } from './transactionHistory'
import { TopUpSteamRoute } from './topUpSteam'
import { CasePageRoute } from './casePage'
import { DailyBonusRoute } from './dailyBonus'
import { LeaderboardRoute } from './leaderboard'
import { SocialRoute } from './social'
import { TasksRoute } from './tasks'
import { ConnectPlatformRoute } from './connectPlatform'

import { FarcanaProfileRoute } from './farcanaProfile'
import { UnifiedProfileRoute } from './unifiedProfilePage'
import { RecommendationsPageRoute } from './recommendations'
import { ExternalUnifiedProfileRoute } from './externalUnifiedProfile'
import { EpicProfileRoute } from './epicProfilePage'
import { shopPageRoute } from './shopPage'

export const Pages = createRoutesView({
  routes: [
    DevToolsRoute,
    EpicProfileRoute,
    LastProgressRoute,
    FarcanaProfileRoute,
    StartPageRoute,
    AuthPageRoute,
    OnboardingPageRoute,
    MainPageRoute,
    RecommendationsPageRoute,
    ProfilePageRoute,
    UpdatePageRoute,
    TestPageRoute,
    PrivateErrorPageRoute,
    OtherErrorPageRoute,
    newAuthRoute,
    CasesListPageRoute,
    TonConnectPageRoute,
    RewardPageRoute,
    DoubleConnectionErrorPageRoute,
    ConnectSteamPageRoute,
    NewsRoute,
    TransactionStatusRoute,
    TransactionHistoryRoute,
    TopUpSteamRoute,
    CasePageRoute,
    DailyBonusRoute,
    LeaderboardRoute,
    SocialRoute,
    TasksRoute,
    ConnectPlatformRoute,
    UnifiedProfileRoute,
    ExternalUnifiedProfileRoute,
    shopPageRoute,
  ],
})
